import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { fetchAuthUnsynced, importAuthUser, fetchUsers } from '../actions/users';

const USER_TYPES = ['GOD', 'ROOT', 'HHRR', 'LIMITED', 'CASH'];

const AuthUserSyncModal = ({ onClose, fetchAuthUnsynced, importAuthUser, fetchUsers }) => {
  const [loading, setLoading] = useState(true);
  const [authUsers, setAuthUsers] = useState([]);
  const [error, setError] = useState(null);
  const [importing, setImporting] = useState(null);
  const [imported, setImported] = useState(new Set());
  const [configuring, setConfiguring] = useState(null);
  const [configForm, setConfigForm] = useState({ type: 'LIMITED', workingday: 40, rest: 60 });

  useEffect(() => {
    setLoading(true);
    Promise.resolve(fetchAuthUnsynced())
      .then((action) => {
        const users = action?.response || [];
        setAuthUsers(Array.isArray(users) ? users : []);
      })
      .catch(() => setError('Error al cargar usuarios Auth'))
      .finally(() => setLoading(false));
  }, [fetchAuthUnsynced]);

  const openConfigure = (user) => {
    setConfiguring(user);
    setConfigForm({ type: 'LIMITED', workingday: 40, rest: 60 });
  };

  const handleConfigChange = (e) => {
    const { name, value } = e.target;
    setConfigForm(prev => ({
      ...prev,
      [name]: (name === 'workingday' || name === 'rest') ? Number(value) : value,
    }));
  };

  const handleImport = async () => {
    if (!configuring) return;
    setImporting(configuring._id);
    setError(null);
    try {
      await Promise.resolve(importAuthUser(configuring._id, {
        type: configForm.type,
        workingday: configForm.workingday,
        rest: configForm.rest,
      }));
      setImported(prev => new Set([...prev, configuring._id]));
      setConfiguring(null);
      fetchUsers();
    } catch {
      setError('Error al importar usuario');
    } finally {
      setImporting(null);
    }
  };

  const unimportedUsers = authUsers.filter(u => !imported.has(u._id));

  return (
    <div
      style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1100 }}
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{ background: '#fff', borderRadius: 8, padding: 24, width: '95%', maxWidth: 640, maxHeight: '85vh', display: 'flex', flexDirection: 'column', boxShadow: '0 10px 30px rgba(0,0,0,0.15)' }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
          <h3 style={{ margin: 0, color: '#022040' }}>Usuarios Auth sin sincronizar</h3>
          <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: 20, cursor: 'pointer', color: '#666' }}>✕</button>
        </div>

        {error && (
          <div style={{ color: '#b22222', marginBottom: 10, padding: '8px 12px', background: '#fff5f5', borderRadius: 4, border: '1px solid #fca5a5' }}>
            {error}
          </div>
        )}

        {loading ? (
          <div style={{ textAlign: 'center', padding: 40, color: '#666' }}>Cargando...</div>
        ) : unimportedUsers.length === 0 ? (
          <div style={{ textAlign: 'center', padding: 40, color: '#0bb937', fontWeight: 600 }}>
            ✓ Todos los usuarios Auth ya están sincronizados
          </div>
        ) : (
          <div style={{ overflowY: 'auto', flex: 1 }}>
            <p style={{ color: '#555', marginBottom: 12, fontSize: '0.9rem' }}>
              Los siguientes usuarios tienen rol ADMIN en Auth pero no existen localmente:
            </p>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.875rem' }}>
              <thead>
                <tr style={{ backgroundColor: '#f0f4fa' }}>
                  <th style={{ padding: '8px 12px', textAlign: 'left', fontWeight: 600, color: '#022040' }}>Nombre</th>
                  <th style={{ padding: '8px 12px', textAlign: 'left', fontWeight: 600, color: '#022040' }}>Email</th>
                  <th style={{ padding: '8px 12px', textAlign: 'left', fontWeight: 600, color: '#022040' }}>Tipo Auth</th>
                  <th style={{ padding: '8px 12px', textAlign: 'center', fontWeight: 600, color: '#022040' }}>Acción</th>
                </tr>
              </thead>
              <tbody>
                {unimportedUsers.map((u, idx) => (
                  <tr key={u._id} style={{ backgroundColor: idx % 2 === 0 ? '#fff' : '#f8f9fb', borderBottom: '1px solid #eee' }}>
                    <td style={{ padding: '8px 12px', color: '#022040', fontWeight: 500 }}>{u.fullname}</td>
                    <td style={{ padding: '8px 12px', color: '#555' }}>{u.email}</td>
                    <td style={{ padding: '8px 12px', color: '#555' }}>{u.type}</td>
                    <td style={{ padding: '8px 12px', textAlign: 'center' }}>
                      <button
                        onClick={() => openConfigure(u)}
                        disabled={importing === u._id}
                        style={{
                          background: '#022040', color: '#fff', border: 'none', borderRadius: 6,
                          padding: '5px 14px', cursor: 'pointer', fontSize: '0.8rem', fontWeight: 600,
                        }}
                      >
                        Importar
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {configuring && (
          <div style={{ marginTop: 16, padding: 16, border: '1px solid #c8d5e8', borderRadius: 8, background: '#f7faff' }}>
            <h4 style={{ margin: '0 0 12px 0', color: '#022040' }}>
              Configurar: <span style={{ fontWeight: 400 }}>{configuring.fullname}</span>
            </h4>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 10 }}>
              <div>
                <label style={{ display: 'block', fontWeight: 600, marginBottom: 4, fontSize: '0.85rem' }}>Tipo</label>
                <select name="type" value={configForm.type} onChange={handleConfigChange} className="form-control" style={{ fontSize: '0.875rem' }}>
                  {USER_TYPES.map(t => (
                    <option key={t} value={t}>{t}</option>
                  ))}
                </select>
              </div>
              <div>
                <label style={{ display: 'block', fontWeight: 600, marginBottom: 4, fontSize: '0.85rem' }}>Jornada semanal (h)</label>
                <input name="workingday" type="number" value={configForm.workingday} onChange={handleConfigChange} className="form-control" style={{ fontSize: '0.875rem' }} />
              </div>
              <div>
                <label style={{ display: 'block', fontWeight: 600, marginBottom: 4, fontSize: '0.85rem' }}>Descanso (min)</label>
                <select name="rest" value={configForm.rest} onChange={handleConfigChange} className="form-control" style={{ fontSize: '0.875rem' }}>
                  <option value={0}>Ninguno</option>
                  <option value={30}>30 min</option>
                  <option value={60}>1 hora</option>
                </select>
              </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 12 }}>
              <button onClick={() => setConfiguring(null)} className="btn btn-secondary" style={{ fontSize: '0.85rem' }}>Cancelar</button>
              <button
                onClick={handleImport}
                disabled={importing === configuring._id}
                className="btn btn-primary"
                style={{ fontSize: '0.85rem' }}
              >
                {importing === configuring._id ? 'Importando...' : 'Confirmar importación'}
              </button>
            </div>
          </div>
        )}

        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16 }}>
          <button onClick={onClose} className="btn btn-secondary">Cerrar</button>
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = { fetchAuthUnsynced, importAuthUser, fetchUsers };

export default connect(null, mapDispatchToProps)(AuthUserSyncModal);
